import React from "react";


export const API_KEY = 'API-Key aadd5f8b42da8c9b1ae2d68dbb36bf94689c2629';
export const leadtubWebsite = "https://Leadtub.se/";


export const COUNTRYCODES = {
    "SWEDEN": "+46",

}
export const dealstages = {
    INKOMMENLEAD: "appointmentscheduled",
    OFFERTSKAPAD: '47368172',
    OFFERTSKICKAD: "qualifiedtobuy",
    OFFERTGODKAND: "17878477",
    OFFERTNEKAD: "17878478",
    OFFERTSEDD: "41454020"
}

export const dealstagesarr = [
    "INKOMMENLEAD: appointmentscheduled",
    'OFFERTSKAPAD: 47368172',
    "OFFERTSKICKAD: qualifiedtobuy",
    "OFFERTGODKÄND: 17878477",
    "OFFERTNEKAD: 17878478",
    "OFFERTSEDD: 41454020"
]


export const pandadocstatuses =
    [
        "document.draft",
        "document.send",
        "document.signed",
        "document.viewed",
        "document.declined",
        "document.completed"
    ]


export const formatTime = (value) => {

}

export const returnAuthBool = (value) => {
    switch (value) {
        case 'Webb':
            return true;
        case 'App':
            return false;
        case 'superadmin':
            return true;

        default:
            return false;

    }
}

export const pandadocstatusesJSON = {
    draft: 'document.draft',
    sent: 'document.sent',
    signed: 'document.signed',
    viewed: 'document.viewed',
    rejected: 'document.rejected',
    declined: 'document.declined',
    completed: 'document.completed'
}

export const formatText = (value) => {

    switch (value) {
        case "document.draft":

            return "Offert Skapad"

        case "document.sent":
            return "Offert Skickad"

        case "document.signed":
            return "Offert signerat"

        case "document.viewed":
            return "Offert sett av kund "

        case "document.rejected":
            return "Kund nekade offert"

        case "document.declined":
            return "Offert nekad av kund"

        case "document.completed":
            return "Offert Godkänd"

        case dealstages.INKOMMENLEAD:
            return 'lead inkommen';

        case dealstages.OFFERTSKAPAD:
            return "Offert Skapad";

        case dealstages.OFFERTSEDD:
            return "Offert sedd av kund";

        case dealstages.OFFERTSKICKAD:
            return "Offert skickad";

        case dealstages.OFFERTNEKAD:
            return "Offert nekad av kund";

        case dealstages.OFFERTGODKAND:
            return "Offert godkänd av kund";

        default:
            return "Offert ej skapad"


    }

}

export const formatAllowWebText = (text) => {
    switch (text) {
        case true:
            return "Tillgång till Web";

        case false:
            return "Endast tillgång till app";

        default:
            return "ej tillgång";
    }
}

export const formatSuperAdminText = (text) => {
    switch (text) {
        case true:
            return "Leadtub-Admin";

        case false:
            return "Ej Leadtub-Admin";

        default:
            return "Variablen finns ej"
    }
}

export const svgs = [];

const overviewsvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.65">
                <path
                    d="M8.66663 1.36731V7.33331H14.6326C14.3193 4.18864 11.8113 1.68064 8.66663 1.36731V1.36731ZM11.9793 13.336C13.4386 12.2446 14.442 10.576 14.6326 8.66664H9.17729L11.9793 13.336Z"
                    fill="#CFCFCF"/>
                <path
                    d="M7.33337 7.99998V1.36731C3.96937 1.70331 1.33337 4.54931 1.33337 7.99998C1.33337 11.676 4.32404 14.6666 8.00004 14.6666C8.98155 14.6654 9.95049 14.4458 10.8367 14.024C10.8367 14.024 7.33471 8.08064 7.33404 8.00331C7.33396 8.00217 7.33374 8.00105 7.33337 7.99998V7.99998Z"
                    fill="#CFCFCF"/>
            </g>
        </svg>
    )
}

const leadssvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M0 6.66666H12L7.00533 12.7293V16L4.99467 14.6667V12.7293L0 6.66666V6.66666ZM6.16733 7.33332H5.83267V7.68866C5.18067 7.77799 4.832 8.18466 4.832 8.63866C4.832 9.45132 5.78667 9.57532 6.09867 9.71999C6.524 9.90932 6.44533 10.3033 6.06 10.39C5.726 10.4653 5.3 10.334 4.97933 10.21L4.82667 10.758C5.12667 10.912 5.48533 10.9947 5.83267 11.0007V11.3333H6.16733V10.982C6.72267 10.9047 7.174 10.6 7.17333 10.0273C7.17333 9.31266 6.42533 9.11332 5.85133 8.84532C5.50333 8.66532 5.54733 8.23599 6.046 8.20666C6.32333 8.18999 6.608 8.27199 6.86533 8.36199L6.986 7.81266C6.68267 7.72066 6.41 7.67866 6.16733 7.67266V7.33332V7.33332ZM0.000666618 5.99999H2.25133C2.24067 3.56066 3.37467 4.62132 3.37467 2.68066C3.37467 1.93133 2.88333 1.52466 2.25067 1.52466C1.316 1.52466 0.666 2.41332 1.55067 4.07532C1.84133 4.62132 1.24067 4.75066 0.596 4.89932C0.0366667 5.02732 0 5.29932 0 5.76999L0.000666618 5.99999ZM11.404 4.89932C10.7587 4.75066 10.1587 4.62132 10.4493 4.07532C11.334 2.41332 10.684 1.52466 9.74933 1.52466C9.11733 1.52466 8.62533 1.93133 8.62533 2.68066C8.62533 4.62132 9.75933 3.56066 9.74867 5.99999H11.9987L12 5.76999C12 5.29932 11.9633 5.02732 11.404 4.89932V4.89932ZM8.99867 5.99999H3.00067L3 5.68999C3 5.06466 3.05 4.70332 3.794 4.53199C4.636 4.33866 5.466 4.16599 5.06667 3.43399C3.88333 1.26399 4.72933 0.0333252 5.99933 0.0333252C7.24467 0.0333252 8.11267 1.21799 6.93267 3.43399C6.54467 4.16199 7.34533 4.33466 8.20467 4.53199C8.95 4.70332 8.99933 5.06532 8.99933 5.69199L8.99867 5.99999Z"
                  fill="white"/>
        </svg>

    )
}

const usersvg = () => {
    return (
        <svg width="19" height="19" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 8.88794C3.23858 8.88794 1 11.0612 1 13.7421V13.9556C1 14.5079 1.44772 14.9556 2 14.9556H10C10.5523 14.9556 11 14.5079 11 13.9556V13.7421C11 11.0612 8.76142 8.88794 6 8.88794Z"
                fill="#CFCFCF" stroke="#CFCFCF"/>
            <ellipse cx="6.00064" cy="4.64059" rx="3.75003" ry="3.64059" fill="#CFCFCF" stroke="#CFCFCF"
                     strokeLinecap="square"/>
        </svg>

    )
}
const settingssvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.65">
                <path
                    d="M17.4521 8.45061L15.6637 7.91728C15.5401 7.48598 15.37 7.06933 15.1566 6.67462L16.0321 5.0373C16.0649 4.97549 16.077 4.90475 16.0664 4.83558C16.0558 4.76641 16.0232 4.70248 15.9734 4.6533L14.6974 3.3733C14.6482 3.32353 14.5842 3.29094 14.515 3.28037C14.4457 3.2698 14.3749 3.28182 14.3131 3.31464L12.6848 4.18397C12.2858 3.96032 11.8633 3.78146 11.4249 3.65064L10.8911 1.88531C10.8685 1.82025 10.8258 1.76403 10.7692 1.72474C10.7126 1.68544 10.645 1.6651 10.5761 1.66665H8.77165C8.70232 1.66697 8.63491 1.68938 8.57922 1.73063C8.52353 1.77188 8.48247 1.8298 8.46201 1.89598L7.92816 3.65597C7.48614 3.78609 7.05999 3.96497 6.65758 4.1893L5.05602 3.3253C4.99416 3.29249 4.92335 3.28047 4.8541 3.29104C4.78486 3.3016 4.72088 3.33419 4.67164 3.38397L3.37438 4.64796C3.32455 4.69715 3.29193 4.76107 3.28135 4.83025C3.27077 4.89942 3.2828 4.97016 3.31565 5.03196L4.1805 6.63196C3.95631 7.03227 3.77726 7.45619 3.64664 7.89595L1.87958 8.42928C1.81334 8.44972 1.75536 8.49074 1.71407 8.54637C1.67279 8.60201 1.65035 8.66935 1.65002 8.73861V10.5413C1.65035 10.6105 1.67279 10.6779 1.71407 10.7335C1.75536 10.7891 1.81334 10.8302 1.87958 10.8506L3.65732 11.3839C3.78937 11.8164 3.96838 12.2331 4.19117 12.6266L3.31565 14.3012C3.2828 14.3631 3.27077 14.4338 3.28135 14.503C3.29193 14.5721 3.32455 14.6361 3.37438 14.6852L4.65029 15.9599C4.69952 16.0097 4.76351 16.0423 4.83275 16.0528C4.90199 16.0634 4.9728 16.0514 5.03467 16.0186L6.68428 15.1386C7.07451 15.3489 7.48614 15.517 7.91214 15.6399L8.446 17.4372C8.46645 17.5034 8.50752 17.5613 8.56321 17.6026C8.6189 17.6438 8.68631 17.6662 8.75563 17.6666H10.5601C10.6294 17.6662 10.6968 17.6438 10.7525 17.6026C10.8082 17.5613 10.8492 17.5034 10.8697 17.4372L11.4036 15.6346C11.8259 15.511 12.2339 15.343 12.6207 15.1332L14.281 16.0186C14.3429 16.0514 14.4137 16.0634 14.4829 16.0528C14.5522 16.0423 14.6162 16.0097 14.6654 15.9599L15.9413 14.6852C15.9911 14.6361 16.0238 14.5721 16.0344 14.503C16.0449 14.4338 16.0329 14.3631 16 14.3012L15.1138 12.6479C15.326 12.26 15.496 11.8506 15.621 11.4266L17.4201 10.8933C17.4863 10.8728 17.5443 10.8318 17.5856 10.7762C17.6269 10.7205 17.6493 10.6532 17.6497 10.5839V8.76528C17.6528 8.69896 17.6356 8.63326 17.6003 8.57702C17.565 8.52077 17.5133 8.47666 17.4521 8.45061ZM9.67387 12.5999C9.09314 12.5999 8.52545 12.4279 8.0426 12.1056C7.55974 11.7833 7.1834 11.3251 6.96117 10.7891C6.73893 10.2531 6.68079 9.66335 6.79408 9.09434C6.90738 8.52534 7.18702 8.00267 7.59766 7.59244C8.00829 7.1822 8.53147 6.90283 9.10104 6.78965C9.67061 6.67647 10.261 6.73456 10.7975 6.95657C11.334 7.17859 11.7926 7.55456 12.1152 8.03694C12.4379 8.51932 12.6101 9.08645 12.6101 9.66661C12.6101 10.4446 12.3007 11.1907 11.7501 11.7408C11.1994 12.2909 10.4526 12.5999 9.67387 12.5999Z"
                    fill="#CFCFCF"/>
            </g>
        </svg>

    )
}

const contactussvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.48577 1.75741e-07C6.35471 -0.000262465 5.24325 0.293861 4.26168 0.85318C3.28012 1.4125 2.46257 2.21757 1.89018 3.18849C1.3178 4.15942 1.01047 5.26244 0.998693 6.3881C0.986919 7.51375 1.27111 8.6229 1.82307 9.60548L1.02979 11.6732C0.963762 11.845 0.947013 12.0318 0.981412 12.2126C1.01581 12.3934 1.1 12.5611 1.2246 12.6971C1.34919 12.833 1.50929 12.9319 1.68703 12.9825C1.86477 13.0332 2.05316 13.0337 2.23118 12.9841L4.71279 12.2919C5.59187 12.7053 6.55308 12.9167 7.52533 12.9105C8.49758 12.9042 9.45598 12.6805 10.3296 12.2559C11.2033 11.8313 11.9699 11.2166 12.5727 10.4574C13.1754 9.69809 13.599 8.81366 13.812 7.86949C14.025 6.92532 14.022 5.94556 13.8032 5.0027C13.5844 4.05984 13.1554 3.178 12.548 2.42241C11.9406 1.66682 11.1703 1.0568 10.294 0.637499C9.41779 0.218193 8.45803 0.000321034 7.48577 1.75741e-07ZM7.47878 3.87417C7.12156 3.94369 6.73041 4.17409 6.42308 4.71435C6.39071 4.77108 6.34743 4.82091 6.29572 4.861C6.244 4.90109 6.18486 4.93064 6.12167 4.94798C6.05847 4.96532 5.99247 4.9701 5.92742 4.96204C5.86237 4.95399 5.79955 4.93327 5.74255 4.90106C5.68555 4.86884 5.63548 4.82577 5.59521 4.7743C5.55493 4.72283 5.52524 4.66396 5.50782 4.60107C5.4904 4.53818 5.48559 4.47248 5.49368 4.40774C5.50177 4.343 5.52259 4.28048 5.55496 4.22375C5.99501 3.45308 6.62065 3.02902 7.2872 2.89992C7.9074 2.78334 8.54884 2.91195 9.07532 3.25843C9.55827 3.57623 9.94842 4.09563 9.96039 4.71832C9.97336 5.36882 9.57623 5.95575 8.84382 6.38677C8.3469 6.67875 8.15332 6.87737 8.0705 7.00945C8.00065 7.12068 7.98468 7.22198 7.98468 7.44841C7.98468 7.58011 7.93212 7.70641 7.83855 7.79954C7.74499 7.89266 7.61809 7.94498 7.48577 7.94498C7.35345 7.94498 7.22654 7.89266 7.13298 7.79954C7.03941 7.70641 6.98685 7.58011 6.98685 7.44841C6.98685 7.17829 7.00082 6.84261 7.22334 6.48509C7.43288 6.1504 7.7911 5.85247 8.33592 5.53169C8.86976 5.21687 8.96655 4.91794 8.96356 4.73918C8.95857 4.5336 8.82187 4.28234 8.52451 4.0867C8.21664 3.88398 7.84186 3.80781 7.47878 3.87417ZM7.73523 10.4278C7.53674 10.4278 7.34639 10.3493 7.20605 10.2096C7.0657 10.0699 6.98685 9.88048 6.98685 9.68294C6.98685 9.48539 7.0657 9.29594 7.20605 9.15626C7.34639 9.01657 7.53674 8.9381 7.73523 8.9381C7.93371 8.9381 8.12406 9.01657 8.26441 9.15626C8.40475 9.29594 8.4836 9.48539 8.4836 9.68294C8.4836 9.88048 8.40475 10.0699 8.26441 10.2096C8.12406 10.3493 7.93371 10.4278 7.73523 10.4278Z"
                fill="#CFCFCF"/>
            <path
                d="M5.526 13.6455C6.13427 14.3505 6.88862 14.9161 7.73724 15.3035C8.58587 15.691 9.50868 15.891 10.4423 15.89C11.4332 15.89 12.3741 15.6685 13.2163 15.2713L15.6979 15.9635C15.8759 16.0129 16.0641 16.0122 16.2417 15.9614C16.4193 15.9106 16.5792 15.8118 16.7037 15.6759C16.8281 15.54 16.9122 15.3723 16.9466 15.1917C16.9809 15.011 16.9642 14.8243 16.8983 14.6526L16.104 12.5849C16.6289 11.6523 16.9282 10.5778 16.9282 9.4347C16.9282 7.50804 16.0801 5.77802 14.734 4.59521C14.8797 5.15534 14.9605 5.74227 14.9685 6.3451C15.5752 7.22401 15.9304 8.28864 15.9304 9.4347C15.9304 10.4775 15.637 11.4517 15.1272 12.281L14.9994 12.4895L15.9673 15.0071L13.1135 14.2126L12.9389 14.3C12.1905 14.6814 11.3424 14.8969 10.4423 14.8969C9.31071 14.8986 8.20649 14.5505 7.28219 13.9008C6.68869 13.8853 6.09915 13.7997 5.526 13.6455Z"
                fill="#CFCFCF"/>
        </svg>

    )
}

const archivesvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 16 16" fill="none">
            <g opacity="0.65" clipPath="url(#clip0_421_1878)">
                <path
                    d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1V12.5C1 13.845 2.021 15 3.357 15H12.643ZM5.5 7H10.5C10.6326 7 10.7598 7.05268 10.8536 7.14645C10.9473 7.24021 11 7.36739 11 7.5C11 7.63261 10.9473 7.75979 10.8536 7.85355C10.7598 7.94732 10.6326 8 10.5 8H5.5C5.36739 8 5.24021 7.94732 5.14645 7.85355C5.05268 7.75979 5 7.63261 5 7.5C5 7.36739 5.05268 7.24021 5.14645 7.14645C5.24021 7.05268 5.36739 7 5.5 7V7ZM0.8 1C0.587827 1 0.384344 1.08429 0.234315 1.23431C0.0842855 1.38434 0 1.58783 0 1.8L0 3C0 3.21217 0.0842855 3.41566 0.234315 3.56569C0.384344 3.71571 0.587827 3.8 0.8 3.8H15.2C15.4122 3.8 15.6157 3.71571 15.7657 3.56569C15.9157 3.41566 16 3.21217 16 3V1.8C16 1.58783 15.9157 1.38434 15.7657 1.23431C15.6157 1.08429 15.4122 1 15.2 1H0.8Z"
                    fill="#CFCFCF"/>
            </g>
            <defs>
                <clipPath id="clip0_421_1878">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}


svgs.push(overviewsvg())
svgs.push(leadssvg())
svgs.push(usersvg())
svgs.push(settingssvg())
svgs.push(contactussvg())
svgs.push(archivesvg())
export const SOCIAL_MEDIAS = () => {
    return (
        <React.Fragment>
            <a href={"https://www.facebook.com/Leadtub-105153414758430"} target="_blank" rel="noopener noreferrer">
                <svg width="105" height="105" viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_891_489)">
                        <rect x="25" y="24" width="55" height="55" rx="16" fill="#5291CA"/>
                    </g>
                    <path
                        d="M41.5312 38.0938C40.1979 38.0938 39.0938 39.1979 39.0938 40.5312V62.4688C39.0938 63.8021 40.1979 64.9062 41.5312 64.9062H63.4688C64.8021 64.9062 65.9062 63.8021 65.9062 62.4688V40.5312C65.9062 39.1979 64.8021 38.0938 63.4688 38.0938H41.5312ZM41.5312 40.5312H63.4688V62.4688H57.1459V54.2422H60.3073L60.7643 50.5859H57.1471V48.224C57.1471 47.1588 57.4079 46.4349 58.9362 46.4349H60.9167V43.1211C60.5791 43.0784 59.4079 43.0065 58.0612 43.0065C55.2519 43.0065 53.3385 44.6969 53.3385 47.8438V50.5859H50.1393V54.2422H53.3373V62.4688H41.5312V40.5312Z"
                        fill="white"/>
                    <defs>
                        <filter id="filter0_d_891_489" x="0" y="0" width="105" height="105"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="1"/>
                            <feGaussianBlur stdDeviation="12.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_891_489"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_891_489"
                                     result="shape"/>
                        </filter>
                    </defs>
                </svg>
            </a>
            <a href="https://www.instagram.com/leadtub/" target="_blank" rel="noopener noreferrer">
                <svg width="105" height="105" viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_890_1677)">
                        <rect x="25" y="24" width="55" height="55" rx="16" fill="#5291CA"/>
                    </g>
                    <path
                        d="M58.4827 38.0866C59.853 38.1496 60.8003 38.351 61.6755 38.6908C62.5054 39.001 63.2567 39.4904 63.876 40.124C64.5096 40.7433 64.999 41.4946 65.3092 42.3245C65.649 43.2009 65.8504 44.147 65.9134 45.5173C65.991 47.216 66 47.8145 66 51.5C66 55.1855 65.991 55.784 65.9134 57.4827C65.8504 58.853 65.649 59.8002 65.3092 60.6766C64.9988 61.5061 64.5095 62.257 63.876 62.876C63.2567 63.5096 62.5054 63.999 61.6755 64.3092C60.7991 64.649 59.853 64.8504 58.4827 64.9134C56.784 64.991 56.1866 65 52.5 65C48.8134 65 48.2149 64.991 46.5173 64.9134C45.147 64.8504 44.1997 64.649 43.3234 64.3092C42.4939 63.9988 41.7429 63.5095 41.124 62.876C40.4904 62.2567 40.001 61.5054 39.6908 60.6755C39.351 59.7991 39.1496 58.853 39.0866 57.4827C39.009 55.7863 39 55.1877 39 51.5C39 47.8134 39.009 47.2137 39.0866 45.5173C39.1496 44.147 39.351 43.1997 39.6908 42.3245C40.001 41.4946 40.4904 40.7433 41.124 40.124C41.743 39.4905 42.4939 39.0012 43.3234 38.6908C44.2009 38.351 45.147 38.1496 46.5173 38.0866C48.2137 38.009 48.8123 38 52.5 38C56.1866 38 56.7863 38.009 58.4827 38.0866ZM52.5 41.0004C48.855 41.0004 48.297 41.0082 46.6534 41.0836C45.6105 41.1309 44.985 41.2636 44.4101 41.4875C43.9208 41.6787 43.6091 41.8812 43.2446 42.2446C42.8801 42.6091 42.6776 42.9208 42.4875 43.4101C42.2648 43.9839 42.1309 44.6105 42.0836 45.6534C42.0082 47.297 42.0004 47.855 42.0004 51.5C42.0004 55.145 42.0082 55.703 42.0836 57.3466C42.1309 58.3895 42.2636 59.015 42.4875 59.5888C42.6787 60.0793 42.8812 60.3909 43.2446 60.7554C43.6091 61.1199 43.9208 61.3224 44.4101 61.5125C44.9839 61.7353 45.6105 61.8691 46.6534 61.9164C48.2981 61.9918 48.8561 61.9996 52.5 61.9996C56.145 61.9996 56.7019 61.9918 58.3466 61.9164C59.3895 61.8691 60.015 61.7364 60.5899 61.5125C61.0793 61.3212 61.3909 61.1187 61.7554 60.7554C62.1199 60.3909 62.3224 60.0793 62.5125 59.5899C62.7353 59.0161 62.8691 58.3895 62.9164 57.3466C62.9918 55.7019 62.9996 55.1439 62.9996 51.5C62.9996 47.8561 62.9918 47.2981 62.9164 45.6534C62.8691 44.6105 62.7364 43.985 62.5125 43.4113C62.3534 42.9692 62.0943 42.5699 61.7554 42.2446C61.4301 41.9057 61.0308 41.6465 60.5888 41.4875C60.015 41.2648 59.3884 41.1309 58.3455 41.0836C56.7019 41.0082 56.1439 41.0004 52.4989 41.0004H52.5ZM52.5 58.4998C50.6436 58.4998 48.8631 57.7623 47.5504 56.4496C46.2377 55.1369 45.5002 53.3564 45.5002 51.5C45.5002 49.6436 46.2377 47.8631 47.5504 46.5504C48.8631 45.2377 50.6436 44.5002 52.5 44.5002C54.3564 44.5002 56.1369 45.2377 57.4496 46.5504C58.7623 47.8631 59.4998 49.6436 59.4998 51.5C59.4998 53.3564 58.7623 55.1369 57.4496 56.4496C56.1369 57.7623 54.3564 58.4998 52.5 58.4998ZM52.5 55.5005C53.561 55.5005 54.5785 55.079 55.3288 54.3288C56.079 53.5785 56.5005 52.561 56.5005 51.5C56.5005 50.439 56.079 49.4215 55.3288 48.6712C54.5785 47.921 53.561 47.4995 52.5 47.4995C51.439 47.4995 50.4215 47.921 49.6712 48.6712C48.921 49.4215 48.4995 50.439 48.4995 51.5C48.4995 52.561 48.921 53.5785 49.6712 54.3288C50.4215 55.079 51.439 55.5005 52.5 55.5005ZM59.4998 45.9999C59.1019 45.9999 58.7203 45.8418 58.439 45.5605C58.1576 45.2791 57.9996 44.8976 57.9996 44.4997C57.9996 44.1018 58.1576 43.7202 58.439 43.4389C58.7203 43.1576 59.1019 42.9995 59.4998 42.9995C59.8976 42.9995 60.2792 43.1576 60.5605 43.4389C60.8419 43.7202 60.9999 44.1018 60.9999 44.4997C60.9999 44.8976 60.8419 45.2791 60.5605 45.5605C60.2792 45.8418 59.8976 45.9999 59.4998 45.9999Z"
                        fill="white"/>
                    <defs>
                        <filter id="filter0_d_890_1677" x="0" y="0" width="105" height="105"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="1"/>
                            <feGaussianBlur stdDeviation="12.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_890_1677"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_890_1677" result="shape"/>
                        </filter>
                    </defs>
                </svg>
            </a>
            <a href="https://www.linkedin.com/company/leadtub/" target={"_blank"} rel="noopener noreferrer">

                <svg width="105" height="105" viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_890_1676)">
                        <rect x="25" y="24" width="55" height="55" rx="16" fill="#5291CA"/>
                    </g>
                    <path
                        d="M64.1463 38.7188H41.8537C40.675 38.7188 39.7188 39.675 39.7188 40.8537V63.1463C39.7188 64.325 40.675 65.2812 41.8537 65.2812H64.1463C65.325 65.2812 66.2812 64.325 66.2812 63.1463V40.8537C66.2812 39.675 65.325 38.7188 64.1463 38.7188ZM64.1463 63.1562C49.2779 63.1529 41.8438 63.1496 41.8438 63.1463C41.8471 48.2779 41.8504 40.8438 41.8537 40.8438C56.7221 40.8471 64.1562 40.8504 64.1562 40.8537C64.1529 55.7221 64.1496 63.1562 64.1463 63.1562ZM43.6566 48.6764H47.5979V61.3533H43.6566V48.6764ZM45.6289 46.9432C46.8873 46.9432 47.9133 45.9205 47.9133 44.6588C47.9133 44.3588 47.8542 44.0617 47.7394 43.7846C47.6246 43.5074 47.4563 43.2556 47.2442 43.0435C47.0321 42.8314 46.7803 42.6631 46.5031 42.5483C46.2259 42.4335 45.9289 42.3744 45.6289 42.3744C45.3289 42.3744 45.0319 42.4335 44.7547 42.5483C44.4776 42.6631 44.2257 42.8314 44.0136 43.0435C43.8015 43.2556 43.6332 43.5074 43.5184 43.7846C43.4036 44.0617 43.3445 44.3588 43.3445 44.6588C43.3412 45.9205 44.3639 46.9432 45.6289 46.9432ZM54.0061 55.0812C54.0061 53.4277 54.3215 51.8273 56.3701 51.8273C58.3889 51.8273 58.4188 53.7166 58.4188 55.1875V61.3533H62.3566V54.4006C62.3566 50.9873 61.6195 48.3609 57.6318 48.3609C55.716 48.3609 54.4311 49.4135 53.9031 50.4096H53.85V48.6764H50.0682V61.3533H54.0061V55.0812Z"
                        fill="white"/>
                    <defs>
                        <filter id="filter0_d_890_1676" x="0" y="0" width="105" height="105"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="1"/>
                            <feGaussianBlur stdDeviation="12.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_890_1676"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_890_1676" result="shape"/>
                        </filter>
                    </defs>
                </svg>
            </a>
            <svg width="105" height="105" viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_890_1671)">
                    <rect x="25" y="24" width="55" height="55" rx="16" fill="#5291CA"/>
                </g>
                <path
                    d="M68.75 51.9016C68.75 51.8242 68.75 51.7364 68.7465 51.6344C68.743 51.3496 68.7359 51.0297 68.7289 50.6887C68.7008 49.7078 68.6516 48.7305 68.5742 47.8094C68.4688 46.5403 68.3141 45.4821 68.1031 44.6875C67.8805 43.8584 67.4442 43.1021 66.8377 42.4945C66.2313 41.8868 65.476 41.4489 64.6473 41.2246C63.6523 40.9574 61.7047 40.7922 58.9625 40.6903C57.6582 40.641 56.2625 40.6094 54.8668 40.5918C54.3781 40.5848 53.9246 40.5813 53.5168 40.5778H52.4832C52.0754 40.5813 51.6219 40.5848 51.1332 40.5918C49.7375 40.6094 48.3418 40.641 47.0375 40.6903C44.2953 40.7957 42.3441 40.961 41.3527 41.2246C40.5238 41.4484 39.7681 41.886 39.1616 42.4938C38.5551 43.1016 38.1189 43.8581 37.8969 44.6875C37.6824 45.4821 37.5312 46.5403 37.4258 47.8094C37.3484 48.7305 37.2992 49.7078 37.2711 50.6887C37.2605 51.0297 37.257 51.3496 37.2535 51.6344C37.2535 51.7364 37.25 51.8242 37.25 51.9016V52.0985C37.25 52.1758 37.25 52.2637 37.2535 52.3657C37.257 52.6504 37.2641 52.9703 37.2711 53.3114C37.2992 54.2922 37.3484 55.2696 37.4258 56.1906C37.5312 57.4598 37.6859 58.518 37.8969 59.3125C38.3469 60.9965 39.6687 62.3254 41.3527 62.7754C42.3441 63.0426 44.2953 63.2078 47.0375 63.3098C48.3418 63.359 49.7375 63.3906 51.1332 63.4082C51.6219 63.4153 52.0754 63.4188 52.4832 63.4223H53.5168C53.9246 63.4188 54.3781 63.4153 54.8668 63.4082C56.2625 63.3906 57.6582 63.359 58.9625 63.3098C61.7047 63.2043 63.6559 63.0391 64.6473 62.7754C66.3312 62.3254 67.6531 61 68.1031 59.3125C68.3176 58.518 68.4688 57.4598 68.5742 56.1906C68.6516 55.2696 68.7008 54.2922 68.7289 53.3114C68.7395 52.9703 68.743 52.6504 68.7465 52.3657C68.7465 52.2637 68.75 52.1758 68.75 52.0985V51.9016ZM66.2188 52.0844C66.2188 52.1582 66.2188 52.2391 66.2152 52.334C66.2117 52.6082 66.2047 52.9106 66.1977 53.2375C66.173 54.1727 66.1238 55.1078 66.05 55.9762C65.9551 57.1082 65.8215 58.0364 65.6562 58.6586C65.4383 59.4707 64.7984 60.1141 63.9898 60.3285C63.2516 60.5254 61.3918 60.6836 58.8641 60.7785C57.5844 60.8278 56.2062 60.8594 54.8316 60.877C54.35 60.884 53.9035 60.8875 53.5027 60.8875H52.4973L51.1684 60.877C49.7937 60.8594 48.4191 60.8278 47.1359 60.7785C44.6082 60.6801 42.7449 60.5254 42.0102 60.3285C41.2016 60.1106 40.5617 59.4707 40.3438 58.6586C40.1785 58.0364 40.0449 57.1082 39.95 55.9762C39.8762 55.1078 39.8305 54.1727 39.8023 53.2375C39.7918 52.9106 39.7883 52.6047 39.7848 52.334C39.7848 52.2391 39.7812 52.1547 39.7812 52.0844V51.9156C39.7812 51.8418 39.7813 51.761 39.7848 51.666C39.7883 51.3918 39.7953 51.0895 39.8023 50.7625C39.827 49.8274 39.8762 48.8922 39.95 48.0239C40.0449 46.8918 40.1785 45.9637 40.3438 45.3414C40.5617 44.5293 41.2016 43.886 42.0102 43.6715C42.7484 43.4746 44.6082 43.3164 47.1359 43.2215C48.4156 43.1723 49.7937 43.1406 51.1684 43.1231C51.65 43.116 52.0965 43.1125 52.4973 43.1125H53.5027L54.8316 43.1231C56.2062 43.1406 57.5809 43.1723 58.8641 43.2215C61.3918 43.3199 63.2551 43.4746 63.9898 43.6715C64.7984 43.8895 65.4383 44.5293 65.6562 45.3414C65.8215 45.9637 65.9551 46.8918 66.05 48.0239C66.1238 48.8922 66.1695 49.8274 66.1977 50.7625C66.2082 51.0895 66.2117 51.3953 66.2152 51.666C66.2152 51.761 66.2188 51.8453 66.2188 51.9156V52.0844ZM49.8711 56.711L58.0273 51.9649L49.8711 47.2891V56.711Z"
                    fill="white"/>

                <filter id="filter0_d_890_1671" x="0" y="0" width="105" height="105"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix"
                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="1"/>
                    <feGaussianBlur stdDeviation="12.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_890_1671"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_890_1671" result="shape"/>
                </filter>

            </svg>
        </React.Fragment>
    )
}
/*

function generateColors() {
    return Math.floor(Math.random() * (250));
}

const declareColours = (len) => {
    let coloursArray = [];

    for (let i = 0; i < len; i++) {

        let rgbColor = 'rgba(' + generateColors() + ',' + generateColors() + ',' + generateColors()
            + ',0.5)';
        coloursArray.push(rgbColor)
    }

    return coloursArray
}

const getLeadsPerUser = () => {
    let amount = userObjects.length;

    let arr = [amount];
    for (let i = 0; i < arr.length; i++) {
        arr.push(5 * i)
    }
    return arr;
}
 */

